import { Col, Row } from "antd"
import FormSearchDesktopSkeleton from "./FormSearchDesktop.skeleton"
import FormSearchMobileSkeleton from "./FormSearchMobile.skeleton"

const FormSearchSkeleton = () => {

  return (
    <Row justify='center'>
      <Col span={24} className="hotels__searching--content">
        <FormSearchDesktopSkeleton />
        <div className="hotels__searching--mobile-hero">
          <FormSearchMobileSkeleton className="hotels__searching--mobile-form-card" />
        </div>
      </Col>
    </Row>
  )
}

export default FormSearchSkeleton